import axios from 'axios'

export default (ctx, inject) => {
  const LOCATION_API_CLIENT = axios.create({
    baseURL: process.env.LOCALIDADE_API,
    timeout: 5000,
    responseType: 'json',
    headers: {
      Accept: 'application/json'
    }
  })

  inject('locationApi', LOCATION_API_CLIENT)
}
